module.exports = __webpack_public_path__ + "a78df08d694cfa3db35a3e79893bd5d6.jpg";


//////////////////
// WEBPACK FOOTER
// ../images/speakers/sarrah-vesselov.jpg
// module id = 454
// module chunks = 0